// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pqeskxWME2MLw0rko6Rk{align-items:center;gap:8px;min-width:100px;display:flex}.Ku7lHfRrx4YzmGqweSN8{text-overflow:ellipsis;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemLabel": `pqeskxWME2MLw0rko6Rk`,
	"itemPhone": `Ku7lHfRrx4YzmGqweSN8`
};
export default ___CSS_LOADER_EXPORT___;
